<template>
  <div class="page px-3" v-if="visible">
    <div>
      <h4 class="function-title">Cláusula de No Repetición</h4>
    </div>
    <b-row>
      <b-col sm="8" offset-sm="2">
        <b-row>
          <b-col sm="12">
            <p class="text-primary" v-if="empresasAsociadas.length > 0">
              <b>Empresas Asociadas a esta póliza:</b>
              <v-select
                multiple
                v-model="empresasElegidas"
                label="text"
                class="mt-2"
                :options="empresasAsociadas"
                :reduce="empresasAsociadas => empresasAsociadas.value"
              ></v-select>
            </p>
          </b-col>
              Cantidad de seleccionados: {{ empresasElegidas.length }}
        </b-row>
        <div class="submit-footer">
          <b-row>
            <b-col></b-col>
            <b-col class="text-right">
              <b-btn variant="primary" @click="generarClausulaNoRepeticion" :disabled="!empresasElegidas.length">
                <i class="fa fa-check" v-if="!sending"></i>
                <i class="fa fa-spinner fa-spin" v-else></i>
                Generar Cláusula de No Repetición
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    nroPoliza: {
      type: Number | String
    },
  },

  data() {
    return {
      visible: false,
      empresasAsociadas: [],
      empresasElegidas: [],
      sending: false,
    };
  },

  methods: {
    generarClausulaNoRepeticion: async function() {
      this.sending = true;
      const payload = {
        nro_pol: this.nroPoliza,
        empresasElegidas: this.empresasElegidas
      };
      await this.$api({
        url: 'clasula-no-repeticion/generar',
        method: 'POST',
        responseType: 'blob',
        data: payload
      }).then(res => {
        var a = document.createElement("a")
        document.body.appendChild(a)
        a.style="display: none"
        const fileURL = URL.createObjectURL(res.data);
        a.href = fileURL
        a.download = this.nroPoliza + "-CLAUSULA_NO_REPETICION.pdf"
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
      }).catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function() {
          toast.error('No se pudo generar y/o descargar la cláusula de no repetición. ' + fr.result.replace(/"/g, ''));
        };
        fr.readAsText(err.response.data);
      });

      this.sending = false;
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.$api(`clasula-no-repeticion/empresas-asociadas/${this.nroPoliza}/${this.endoso}`).then(res => {
          //console.log('poliza '+this.nroPoliza);
          this.empresasAsociadas = res.data.map(item => ({
            text: item.razon_social + ' | CUIT: ' + item.cuit,
            value: [item.razon_social, item.cuit, item.direccion]
          }));
        });
      }
    }
  }
};
</script>
